import { queryOptions } from "@tanstack/react-query";
import { LST_FVT } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { queryKeys } from "~/lib/queryKeys";
import type { LikeListResponse } from "./types";

/** 相手から（自分がもらった）いいね一覧 — lst_fvt */
export const receivedLikeListQueryOptions = queryOptions({
  queryKey: queryKeys.like.received(),
  queryFn: () => apiClient<LikeListResponse>(LST_FVT),
});

/** 自分から（自分が送った）いいね一覧 — lst_fav（さがすでも使うため lib に置いている） */
export { sentLikeListQueryOptions } from "~/lib/queryOptions/sentLikeList";
